/**
 * De groepen van het tabblad Ondersteuning, in deze volgorde. Eén lijst
 * voor de ankernavigatie én de groepen zelf, zodat die niet uit elkaar lopen.
 * 'Facturatie' staat er alleen voor wie hem mag zien; Settings.jsx filtert.
 * @type {Array<{id: string, title: string}>}
 */
const ONDERSTEUNING_GROUPS = [
    { id: 'settings-deelnemers', title: 'Deelnemers' },
    { id: 'settings-facturatie', title: 'Facturatie' },
    { id: 'settings-huishoudens', title: 'Huishoudens' },
    { id: 'settings-agenda', title: 'Agenda en afspraken' },
    { id: 'settings-organisatie', title: 'Organisatie' },
];

/**
 * Een groep instellingen in één omlijnd vlak met een kop: de blokken erin
 * (elk een `dashboard-container`) worden rijen met een dunne scheidslijn in
 * plaats van losse kaarten met veel wit ertussen.
 *
 * @param {object} props
 * @param {string} props.id - Anker voor de navigatie bovenaan het tabblad
 * @param {string} props.title - Kop van de groep
 * @param {React.ReactNode} props.children - De instellingenblokken
 * @returns {JSX.Element}
 */
const SettingsGroup = ({ id, title, children }) => (
    <section className="settings-group" id={id} aria-labelledby={`${id}-title`}>
        <h3 className="settings-group__title" id={`${id}-title`}>{title}</h3>
        <div className="settings-group__body">{children}</div>
    </section>
);

/**
 * De ankernavigatie bovenaan het tabblad: één regel met de groepen.
 *
 * @param {object} props
 * @param {Array<{id: string, title: string}>} props.groups - De groepen, op volgorde
 * @returns {JSX.Element}
 */
const SettingsGroupNav = ({ groups }) => (
    <nav className="settings-group-nav" aria-label="Onderdelen">
        {groups.map((g) => <a key={g.id} href={`#${g.id}`}>{g.title}</a>)}
    </nav>
);

export { SettingsGroupNav, ONDERSTEUNING_GROUPS };
export default SettingsGroup;
